import { Component, ComponentRef, OnInit, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { RegisterComponent } from '../../components/component-lookup';
import { FlexComponent } from '../flex-component/flex.component';
import { FlexItem } from '../../../shared/services/product.service';

@RegisterComponent('FlexContainer')
@Component({
  selector: 'app-flex-container',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './flex-container.component.html',
  styleUrl: './flex-container.component.scss',
  host: { 'class': 'pro-widget' }
})
export class FlexContainerComponent extends FlexComponent implements OnInit {
  columnBorder = input<boolean>(true);

  override ngOnInit(): void {
    super.ngOnInit();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override onChildCreated(child: FlexItem, componentRef: ComponentRef<any>): void {
    if (child.name === 'FlexRow') {
      componentRef.setInput('columnBorder', this.columnBorder);
    }
  }
}
